function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e = "undefined" != typeof globalThis ? globalThis : e || self).dayjs_plugin_arraySupport = t();
}(this, function () {
  "use strict";

  return function (e, t, n) {
    var o = t.prototype,
        i = function i(e) {
      var t = e.date,
          o = e.utc;
      return Array.isArray(t) ? o ? t.length ? new Date(Date.UTC.apply(null, t)) : new Date() : 1 === t.length ? n(String(t[0])).toDate() : new (Function.prototype.bind.apply(Date, [null].concat(t)))() : t;
    },
        a = o.parse;

    o.parse = function (e) {
      e.date = i.bind(this)(e), a.bind(this)(e);
    };
  };
});